import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import SearchResultPage from '../pages/SearchResultPage';
import FlightDetailPage from '../pages/FlightDetailPage';
import FlightConfirmDetailPage from '../pages/FlightConfirmDetailPage';
import SearchResultRoundtripPage from '../pages/SearchResultRoundtripPage';
import Layout from './resuableComponents/Layout';
import SearchResultPromo from '../pages/SearchResultPromo';
import Dashboard from '../pages/Dashboard';
import ProfileForm from '../form/ProfileForm';
import BookingHistory from '../pages/BookingHistory';
import Transaction from '../pages/Transaction';
import ChangePassword from '../pages/ChangePassword';
import SearchResultBus from '../pages/SearchResultBus';
import BusDetailPage from '../pages/BusDetailPage';
import SearchResultInternational from '../pages/SearchResultInternational';
import SearchResultHolidays from '../pages/SearchResultHolidays';
import HolidaysDetailPage from '../pages/HolidaysDetailPage';
import Ticket from './resuableComponents/Ticket';
import Login from './resuableComponents/Login';
import LoginPage from '../pages/LoginPage';
import SearchResultHotel from '../pages/SearchResultHotel';
import AddPackageForm from '../form/AddPackageForm';
import B2CWL from '../pages/B2CWL';
import B2BWL from '../pages/B2BWL';
import B2B2BWL from '../pages/B2B2BWL';
import AMADEUS from '../pages/AMADEUS';
import GALILEO from '../pages/GALILEO';
import SABRE from '../pages/SABRE';
import Travel from '../pages/Travel';
import TravelSol from '../pages/TravelSol';
import FlightApi from '../pages/FlightApi';
import HotelApi from '../pages/HotelApi';
import BusCar from '../pages/BusCar';
import TravelCRM from '../pages/TravelCRM';
import B2CTP from '../pages/B2CTP';
import B2BTP from '../pages/B2BTP';
import B2ETP from '../pages/B2ETP';
import B2B2B from '../pages/B2B2B';
import TourPackage from '../pages/TourPackage';
import FlightBS from '../pages/FlightBS';
import HotelBS from '../pages/HotelBS';
import BCTP from '../pages/BCTP';
import Tour from '../pages/Tour';
import SoftwareTA from '../pages/SoftwareTA';
import FlightExtranet from '../pages/FlightExtranet';
import HotelExtranet from '../pages/HotelExtranet';
import AndroidDev from '../pages/AndroidDev';
import IOS from '../pages/IOS';
import Window from '../pages/Window';
import B2CEcom from '../pages/B2CEcom';
import B2BEcom from '../pages/B2BEcom';
import Vendor from '../pages/Vendor';
import Dilivery from '../pages/Delivery';
import AndroidEcom from '../pages/AndroidEcom';
import IosEcom from '../pages/IosEcom';

const MainRouter = () => {
	return (
		<div>
			<Routes>
				<Route path='/' exact element={<LandingPage />} />
				<Route path='/login' exact element={<LoginPage />} />
				<Route path='/searchresult' exact element={<SearchResultPage />} />
				<Route
					path='/searchresultpromo'
					exact
					element={<SearchResultPromo />}
				/>
				<Route path='/searchresultbus' exact element={<SearchResultBus />} />
				<Route
					path='/searchresulthotel'
					exact
					element={<SearchResultHotel />}
				/>
				<Route
					path='/searchresultholidays'
					exact
					element={<SearchResultHolidays />}
				/>
				<Route path='/b2c-white-label' exact element={<B2CWL />} />
				<Route path='/b2b-white-label' exact element={<B2BWL />} />
				<Route path='/b2b2b-white-label' exact element={<B2B2BWL />} />
				<Route path='/amadeus-api-integration' exact element={<AMADEUS />} />
				<Route path='/galileo-api-integration' exact element={<GALILEO />} />
				<Route path='/sabre-api-integration' exact element={<SABRE />} />
				<Route path='/travel-apis' exact element={<Travel />} />
				<Route path='/travel-api-integration' exact element={<TravelSol />} />
				<Route path='/flight-api-integration' exact element={<FlightApi />} />
				<Route path='/hotel-api-integration' exact element={<HotelApi />} />
				<Route path='/bus-and-car-api-integration' exact element={<BusCar />} />
				<Route path='/travel-crm' exact element={<TravelCRM />} />
				<Route path='/b2c-travel-portal' exact element={<B2CTP />} />
				<Route path='/b2b-travel-portal' exact element={<B2BTP />} />
				<Route path='/b2e-travel-portal' exact element={<B2ETP />} />
				<Route path='/b2b2b-travel-portal' exact element={<B2B2B />} />
				<Route path='/tour-package-system' exact element={<TourPackage />} />
				<Route path='/tour-package-extranet' exact element={<TourPackage />} />
				<Route path='/flight-booking-system' exact element={<FlightBS />} />
				<Route path='/hotel-booking-system' exact element={<HotelBS />} />
				<Route path='/bus-and-car-booking-system' exact element={<BCTP />} />
				<Route path='/tour-operator-software' exact element={<Tour />} />
				<Route path='/vendor-module-development' exact element={<Vendor />} />
				<Route
					path='/ecommerce-module-ios-mobile-app'
					exact
					element={<IosEcom />}
				/>
				<Route
					path='/ecommerce-module-android-mobile-app'
					exact
					element={<AndroidEcom />}
				/>
				<Route
					path='/delivery-person-module-development'
					exact
					element={<Dilivery />}
				/>
				<Route
					path='/b2c-ecommerce-website-development'
					exact
					element={<B2CEcom />}
				/>
				<Route
					path='/b2b-ecommerce-website-development'
					exact
					element={<B2BEcom />}
				/>
				<Route
					path='/travel-portal-android-mobile-app'
					exact
					element={<AndroidDev />}
				/>
				<Route path='/travel-portal-ios-mobile-app' exact element={<IOS />} />
				<Route
					path='/travel-portal-window-mobile-app'
					exact
					element={<Window />}
				/>
				<Route
					path='/hotel-extranet-system'
					exact
					element={<HotelExtranet />}
				/>
				<Route
					path='/flight-extranet-system'
					exact
					element={<FlightExtranet />}
				/>
				<Route
					path='/software-for-travel-agency'
					exact
					element={<SoftwareTA />}
				/>
				<Route
					path='/searchresultroundtrip'
					exact
					element={<SearchResultRoundtripPage />}
				/>
				<Route
					path='/searchresultinternational'
					exact
					element={<SearchResultInternational />}
				/>
				<Route path='/flightbooking' exact element={<FlightDetailPage />} />
				<Route path='/holidaysbooking' exact element={<HolidaysDetailPage />} />
				<Route
					path='/confirmbooking'
					exact
					element={<FlightConfirmDetailPage />}
				/>
				<Route path='/busbooking' exact element={<BusDetailPage />} />
				<Route
					path='/dashboard'
					element={
						<>
							<Layout title={'Overview'}>
								<Dashboard />
							</Layout>
						</>
					}></Route>
				<Route
					path='/profile'
					element={
						<>
							<Layout title={'Profile'}>
								<ProfileForm />
							</Layout>
						</>
					}></Route>
				<Route
					path='/ticket'
					element={
						<>
							<Layout title={'Ticket'}>
								<Ticket />
							</Layout>
						</>
					}></Route>
				<Route
					path='/changepassword'
					element={
						<>
							<Layout title={'Change Password'}>
								<ChangePassword />
							</Layout>
						</>
					}></Route>{' '}
				<Route
					path='/transaction'
					element={
						<>
							<Layout title={'Transaction History'}>
								<Transaction />
							</Layout>
						</>
					}></Route>
				<Route
					path='/booking'
					element={
						<>
							<Layout title={'Transaction History'}>
								<BookingHistory />
							</Layout>
						</>
					}></Route>
				<Route
					path='/addpackage'
					element={
						<>
							<Layout title={'Add Package'}>
								<AddPackageForm />
							</Layout>
						</>
					}></Route>
				<Route path='*' exact element={<h1>Page Not found</h1>} />
			</Routes>
		</div>
	);
};

export default MainRouter;
